import { db, auth } from '@/firebase/config'
import { collection, addDoc } from 'firebase/firestore'

export async function uploadFile(path: string, file: File): Promise<string> {
  try {
    console.log('[Storage] Iniciando upload de arquivo:', { path, fileName: file.name, fileType: file.type })

    // Verifica se o usuário está autenticado
    if (!auth.currentUser) {
      throw new Error('Usuário não está autenticado')
    }

    // Verifica se o arquivo é válido
    if (!file || !(file instanceof File)) {
      throw new Error('Arquivo inválido')
    }

    // Converte o arquivo para base64
    const base64 = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result)
        } else {
          reject(new Error('Erro ao converter arquivo para base64'))
        }
      }
      reader.onerror = (error) => reject(error)
      reader.readAsDataURL(file)
    })

    // Salva a referência no Firestore
    const imageDoc = await addDoc(collection(db, 'images'), {
      path: `${path}/${Date.now()}_${file.name}`,
      base64,
      type: file.type,
      uploadedBy: auth.currentUser.uid,
      uploadedAt: new Date().toISOString()
    })

    console.log('[Storage] Arquivo salvo com sucesso:', imageDoc.id)

    return base64
  } catch (error) {
    console.error('[Storage] Erro ao fazer upload do arquivo:', error)
    throw error
  }
}
